import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=a064a030&scoped=true"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"
import style0 from "./pc.vue?vue&type=style&index=0&id=a064a030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../Users/afei/podcod_saas_project/shoppaas_member_front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a064a030",
  null
  
)

export default component.exports